import script from "./ObservationsTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservationsTile.vue?vue&type=script&setup=true&lang=js"

import "./ObservationsTile.vue?vue&type=style&index=0&id=34b16770&lang=scss"

const __exports__ = script;

export default __exports__